/*
 * @Author: your name
 * @Date: 2021-04-22 14:08:29
 * @LastEditTime: 2021-09-22 14:13:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fe-mall-web\src\api\activity.js
 */
import request from '@/api/request'

/* 神券 */
// 校验是否在活动时间
const actDetacheckActTimeValidil = (params) => {
  return request({
    url: '/api/v1/activity/app/general/checkActTimeValid',
    method: 'get',
    domain: 'activity-app',
    params
  })
}

/* 团购 */
/* 查询活动阶梯信息 */
const ladders = (params) => {
  return request({
    url: '/api/activity/group_purchase/ladders',
    method: 'GET',
    params,
    domain: 'activity-app'
  })
}
/* 获取团购小团信息 */
const shareDetail = (params) => {
  return request({
    url: '/api/activity/group_purchase/shareDetail',
    method: 'GET',
    params,
    domain: 'activity-app'
  })
}
/* 我的团购列表 */
const record = (params) => {
  return request({
    url: '/api/activity/group_purchase/record',
    method: 'GET',
    params,
    domain: 'activity-app'
  })
}
/* 团购 */
const recordItem = (params) => {
  return request({
    url: '/api/activity/group_purchase/record/get',
    method: 'GET',
    params,
    domain: 'activity-app'
  })
}

const enroll = (data) => {
  return request({
    url: '/api/activity/group_purchase/enroll',
    method: 'POST',
    data,
    domain: 'activity-app'
  })
}

const share = (data) => {
  return request({
    url: '/api/activity/group_purchase/share',
    method: 'POST',
    data,
    domain: 'activity-app'
  })
}
const checkActivityOrder = (params) => {
  return request({
    url: '/api/v1/app/trade/order/checkActivityOrder',
    method: 'GET',
    params
  })
}
/* 团购End */

export default {
  actDetacheckActTimeValidil,
  ladders,
  shareDetail,
  record,
  enroll,
  share,
  recordItem,
  checkActivityOrder
}
